import ConfirmationModal from 'components/modal/ConfirmationModal';
import { Button } from '@qcx/ui';
import { IOrderPaymentPlansDetail } from 'interfaces/orders';
import { useApiUrl, useCan, useCustomMutation } from '@refinedev/core';
import { useModal } from '@refinedev/antd';
import { useState } from 'react';

export const CreatePaymentButton = ({
  invoice,
  orderId,
  preferences
}: {
  orderId: string;
  invoice: IOrderPaymentPlansDetail['invoices'][number];
  preferences: Record<string, unknown>;
}) => {
  const apiUrl = useApiUrl();
  const { mutate } = useCustomMutation();

  const [loading, setLoading] = useState(false);

  const generatePayment = () => {
    setLoading(true);
    mutate(
      {
        url: `${apiUrl}/orders/${orderId}/invoices/${invoice.id}/pay`,
        method: 'post',
        values: {
          invoice_id: invoice.id,
          payer: preferences['info']?.['payer'],
          kind: preferences['kind'],
          installments: preferences['installments']
        },
        successNotification: () => {
          return {
            description: 'Tudo certo!',
            message:
              'Seu pagamento foi gerado e o link estará disponível em alguns instantes',
            type: 'success'
          };
        },
        errorNotification: () => {
          return {
            description: 'Algo deu errado',
            message: 'Não foi possível concluir esta ação',
            type: 'error'
          };
        }
      },
      {
        onError: error => {
          // eslint-disable-next-line no-console
          console.log(error);
        },
        onSuccess: () => {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      }
    );

    setLoading(false);
  };

  return (
    <Button
      size="sm"
      loading={loading}
      onClick={generatePayment}
      variant="neutralLink"
    >
      Gerar pagamento
    </Button>
  );
};

export const CreateExternalPaymentButton = ({
  invoice,
  orderId,
  preferences
}: {
  orderId: string;
  invoice: IOrderPaymentPlansDetail['invoices'][number];
  preferences: Record<string, unknown>;
}) => {
  const { data: permission } = useCan({
    resource: 'payment_plans',
    action: 'cancel'
  });

  const showBtn = permission?.can;
  const apiUrl = useApiUrl();
  const { mutate } = useCustomMutation();

  const [loading, setLoading] = useState(false);
  const { show, modalProps, close } = useModal();

  const generatePayment = () => {
    setLoading(true);
    mutate(
      {
        url: `${apiUrl}/orders/${orderId}/invoices/${invoice.id}/resolve`,
        method: 'post',
        values: {
          payer: preferences?.['info']?.['payer'],
          installments: preferences['installments']
        },
        successNotification: () => {
          return {
            description: 'Tudo certo!',
            message: 'A baixa foi realizada e o está sendo processada',
            type: 'success'
          };
        },
        errorNotification: () => {
          return {
            description: 'Algo deu errado',
            message: 'Não foi possível concluir esta ação',
            type: 'error'
          };
        }
      },
      {
        onError: error => {
          setLoading(false);
          close();
          // eslint-disable-next-line no-console
          console.log(error);
        },
        onSuccess: () => {
          setLoading(false);
          close();
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      }
    );
  };

  if (!showBtn) {
    return <></>;
  }

  return (
    <>
      <Button
        size="sm"
        loading={loading}
        onClick={() => show()}
        variant="neutralLink"
      >
        Dar baixa
      </Button>
      <ConfirmationModal
        closable={false}
        okText="Confirmar"
        onOk={generatePayment}
        bodyTitle="Dar baixa"
        bodyText="Ao confirmar essa ação, você se responsabiliza pela garantia de que esse pagamento já foi efetuado. Esta ação não poderá ser desfeita. Deseja continuar?"
        width={500}
        {...modalProps}
      />
    </>
  );
};

export const CancelInvoiceButton = ({
  invoice,
  orderId
}: {
  orderId: string;
  invoice: IOrderPaymentPlansDetail['invoices'][number];
}) => {
  const { data: permission } = useCan({
    resource: 'payment_plans',
    action: 'cancel'
  });

  const showBtn = permission?.can;

  const apiUrl = useApiUrl();
  const { mutate } = useCustomMutation();
  const { show, modalProps, close } = useModal();

  const [loading, setLoading] = useState(false);

  const cancelInvoice = () => {
    setLoading(true);
    mutate(
      {
        url: `${apiUrl}/orders/${orderId}/invoices/${invoice.id}/cancel`,
        method: 'post',
        values: {},
        successNotification: () => {
          return {
            description: 'Tudo certo!',
            message: 'A cobrança da parcela foi cancelada com sucesso!',
            type: 'success'
          };
        },
        errorNotification: () => {
          return {
            description: 'Algo deu errado',
            message: 'Não foi possível concluir esta ação',
            type: 'error'
          };
        }
      },
      {
        onError: error => {
          setLoading(false);
          close();
          // eslint-disable-next-line no-console
          console.log(error);
        },
        onSuccess: () => {
          setLoading(false);
          close();
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      }
    );
  };

  if (!showBtn) {
    return <></>;
  }

  return (
    <>
      <Button
        size="sm"
        loading={loading}
        onClick={() => show()}
        variant="neutralLink"
      >
        Cancelar cobrança
      </Button>
      <ConfirmationModal
        closable={false}
        okText="Confirmar"
        onOk={cancelInvoice}
        bodyTitle="Cancelar cobrança"
        bodyText="Ao confirmar essa ação, você se responsabiliza pela garantia de que esta cobrança foi indevida. Essa ação não poderá ser desfeita. Deseja continuar?"
        width={500}
        {...modalProps}
      />
    </>
  );
};
